function PrivacyEN() {
  return (
    <div className="bg-primary">
      <h1 className="text-3xl font-bold mb-4">Privacy Policy</h1>
      <p className="mb-4 text-secondary">
        This privacy policy applies to the website{" "}
        <a href="https://next.martvanweeghel.nl" className="text-[#4ab6c6]">
          https://next.martvanweeghel.nl
        </a>{" "}
        and the use of the contact form provided by Next Generation (hereinafter
        "we", "us", or "our").
      </p>

      <p className="mb-4 text-secondary">
        We value the privacy of our users highly. This privacy policy describes
        how we collect the email address you provide via the contact form, how
        we use it, and how we protect it. By using our contact form, you agree
        to the terms of this privacy policy.
      </p>

      <h2 className="text-xl font-bold mb-2">Collected Information</h2>
      <ul className="list-disc list-inside mb-4 text-secondary">
        <li>
          Email Address: When you fill out the contact form on our website, we
          collect the email address you provide.
        </li>
      </ul>

      <h2 className="text-xl font-bold mb-2">Use of Information</h2>
      <p className="mb-4 text-secondary">
        We use the collected email address only to respond to your question or
        comment submitted via the contact form. We do not use the email address
        for other purposes, such as marketing emails, without your explicit
        consent.
      </p>

      <h2 className="text-xl font-bold mb-2">Sharing of Information</h2>
      <p className="mb-4 text-secondary">
        We do not share the collected email address with third parties unless
        required by law.
      </p>

      <h2 className="text-xl font-bold mb-2">Security of Information</h2>
      <p className="mb-4 text-secondary">
        We take appropriate measures to protect the email address you provide
        via the contact form from unauthorized access, alteration, disclosure,
        or destruction.
      </p>

      <h2 className="text-xl font-bold mb-2">Links to Other Sites</h2>
      <p className="mb-4 text-secondary">
        Our website may contain links to other sites not operated by us. If you
        click on a link from a third party, you will be directed to that third
        party's site. We strongly advise you to review the privacy policy of
        every site you visit.
      </p>

      <h2 className="text-xl font-bold mb-2">Changes to This Privacy Policy</h2>
      <p className="mb-4 text-secondary">
        We may update our privacy policy from time to time. We will notify you
        of any changes by posting the new privacy policy on this page. We
        encourage you to review this privacy policy periodically for any
        changes. Changes to this privacy policy are effective when they are
        posted on this page.
      </p>

      <h2 className="text-xl font-bold mb-2">Contact Us</h2>
      <p className="text-secondary">
        If you have any questions about this privacy policy, please contact us
        at{" "}
        <a href="mailto:next@martvanweeghel.nl" className="text-[#4ab6c6]">
          next@martvanweeghel.nl
        </a>
        .
      </p>
    </div>
  );
}

export default PrivacyEN;
